import React, { FC, useEffect, useState } from "react";
import classes from "./App.module.scss";
import { About } from "./components/About/About";
import { Ambassadors } from "./components/Ambassadors/Ambassadors";
import { Categories } from "./components/Categories/Categories";
import { Club } from "./components/Club/Club";
import { Download } from "./components/Download/Download";
import { Footer } from "./components/Footer/Footer";
import { Header } from "./components/Header/Header";
import { Offers } from "./components/Offers/Offers";
import { Partners } from "./components/Partners/Partners";
import { Referral } from "./components/Referral/Referral";
import { Register } from "./components/Register/Register";
import { Roadmap } from "./components/Roadmap/Roadmap";
import { Team } from "./components/Team/Team";
import { Tokenomics } from "./components/Tokenomics/Tokenomics";
import { Language } from "./shared/components/Language";
import { Loader } from "./shared/components/Loader/Loader";
import clsx from "clsx";

const App: FC = () => {
	const [isLoading, setIsLoading] = useState(true);
	const [isContentVisible, setIsContentVisible] = useState(false);

	useEffect(() => {
		setTimeout(() => {
			setIsLoading(false);
		}, 1500);

		setTimeout(() => {
			setIsContentVisible(true);
		}, 500);
	}, []);

	const contentClassName = clsx(classes.content, {
		[classes.open]: !isLoading && isContentVisible,
	});

	return (
		<div className={classes.wrapper}>
			<Loader setIsLoading={setIsLoading} />

			<div className={contentClassName}>
				{isContentVisible && (
					<Language>
						<Header />
						<About />
						<Download />
						<Offers />
						<Club />
						<Categories />
						<Tokenomics />
						<Referral />
						<Roadmap />
						<Partners />
						<Team />
						<Ambassadors />
						<Register />
						<Footer />
					</Language>
				)}
			</div>
		</div>
	);
};

export default App;
